module.exports = __webpack_public_path__ + "static/media/m_eyebrowshape_s_vector.eee0ccd0.svg";